import { Modal } from "../ui/modal/Modal"

import { useRef, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const ModalCompartir = ({ show, link }) => {
  const textInput = useRef(null)

  const force_focus = () => {
    textInput.current.focus()
    textInput.current.select()
  }

  useEffect(force_focus, [])

  const secure = window.location.protocol.includes("https"),
    local = window.location.hostname === "localhost",
    copyAllowed = secure || local

  const onClickCopy = (e) => {
    e.preventDefault()
    force_focus()
    if (copyAllowed) navigator.clipboard.writeText(link)
    // eslint-disable-next-line
    else document.execCommand("copy")
  }

  const ModalFooter = () => {
    const [disabled, setCopiado] = useState(false)

    const handleClick = (e) => {
      setCopiado(true)
      onClickCopy(e)
      setTimeout(() => setCopiado(false), 2500)
    }

    const { t } = useTranslation()

    return (
      <>
        <div className="row justify-content-md-center">
          <div
            className="col-6"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              disabled={disabled}
              className={
                "btn w-100 " + (disabled ? "btn-light" : "btn-primary")
              }
              onClick={handleClick.bind(this)}
            >
              {disabled
                ? t(`modals.modal_compartir.copied`)
                : t(`modals.modal_compartir.copy_link`)}
            </button>
          </div>

          <div
            className="col-6"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <a
              href={`https://web.whatsapp.com/send?text=${link}`}
              data-action="share/whatsapp/share"
            >
              <button type="button" className="btn btn-success w-100">
                {t(`modals.modal_compartir.share_on_wpp`)}
              </button>
            </a>
          </div>
        </div>
      </>
    )
  }

  const Body = () => {
    return (
      <>
        <div className="d-flex flex-row justify-content-center my-4">
          <div className="col col-auto">
            <input
              ref={textInput}
              type="text"
              className="form-control"
              value={link}
            />
          </div>
        </div>
      </>
    )
  }

  const { t } = useTranslation()

  return (
    <>
      <Modal
        id="compartir-modal"
        show={show}
        className="darkie"
        header={<center>{t(`modals.modal_compartir.header`)}</center>}
        body={<Body />}
        footer={<ModalFooter />}
      />
    </>
  )
}
